import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { useLanguage } from '../Context/LanguageContext';
import PageTransition from './PageTransition';

const NotFound = () => {
  const { language } = useLanguage();

  return (
    <PageTransition>
    <section className="not-found-section">
      <div className="not-found-content">
        <motion.div
          initial={{ opacity: 0, scale: 0.8 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ duration: 0.5 }}
        >
          <h1 className="not-found-code">404</h1>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5, delay: 0.2 }}
        >
          <h2 className="not-found-title">
            {language === 'tr' ? 'Sayfa Bulunamadı' : 'Page Not Found'}
          </h2>
          <p className="not-found-message">
            {language === 'tr'
              ? 'Aradığınız sayfa mevcut değil veya taşınmış olabilir.'
              : 'The page you are looking for does not exist or may have been moved.'}
          </p>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5, delay: 0.4 }}
          className="not-found-actions"
        >
          <Link to="/" className="not-found-btn primary">
            <i className="fa fa-home" aria-hidden="true"></i>
            {language === 'tr' ? 'Ana Sayfaya Dön' : 'Go Home'}
          </Link>
          <Link to="/members" className="not-found-btn secondary">
            <i className="fa fa-map-marker" aria-hidden="true"></i>
            {language === 'tr' ? 'Üye Haritası' : 'Member Map'}
          </Link>
        </motion.div>
      </div>
    </section>
    </PageTransition>
  );
};

export default NotFound;
